import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconChevronDown = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z" }, void 0) }, void 0));
const Memo = memo(SvgIconChevronDown);
export default Memo;
//# sourceMappingURL=IconChevronDown.js.map